<template>
  <v-divider v-bind="$attrs" />
</template>

<script>
export default { name: 'JexyDivider' }
</script>
